export default __webpack_public_path__ + "static/media/virtual-bg8.55817d6d.png";